import type { FC } from 'react';
import { useEffect, useMemo, useRef } from 'react';
import { selectUserIsAuthenticated } from '@mwl/core-lib';
import { useTypedDispatch, useTypedSelector } from '@/hooks';
import { selectIsShowMobileCoupon, setShowMobileCoupon, setShowPreviewCoupon } from '@/store';
import { CouponMobile } from './components/CouponMobile/CouponMobile';
import { CouponMobilePreview } from './components/CouponMobilePreview/CouponMobilePreview';
import { CouponWrapper } from './components/CouponWrapper/CouponWrapper';
import { useCouponData } from './SportCoupon.hooks';
import type { SportCouponProps } from './SportCoupon.types';
import styles from './SportCoupon.module.scss';
const quickBetPopupMinHeights = {
  mobileCoupon: 'auto',
  default: '136px'
};
const SportCoupon: FC<SportCouponProps> = ({
  isMobileView
}) => {
  const dispatch = useTypedDispatch();
  const couponContainer = useRef<HTMLDivElement>(null);
  const isShowMobileCoupon = useTypedSelector(selectIsShowMobileCoupon);
  const isAuth = useTypedSelector(selectUserIsAuthenticated);
  useEffect(() => {
    if (!isMobileView) {
      dispatch(setShowMobileCoupon(false));
      dispatch(setShowPreviewCoupon(false));
    }
  }, [isMobileView, dispatch]);
  useCouponData();
  const minHeight = useMemo(() => {
    if (isMobileView) {
      return quickBetPopupMinHeights.mobileCoupon;
    }
    return quickBetPopupMinHeights.default;
  }, [isMobileView]);
  return <div className={styles.root} style={{
    [('--coupon-min-height' as string)]: minHeight
  }} data-sentry-component="SportCoupon" data-sentry-source-file="SportCoupon.tsx">
      {isMobileView && <CouponMobilePreview />}
      {isMobileView && <CouponMobile isShowPopup={isAuth && isShowMobileCoupon} />}
      {!isMobileView && <CouponWrapper ref={couponContainer} />}
    </div>;
};
export { SportCoupon };